import type { Location } from "@/sales-tools/detected-cues/stores/DetectedCuesStore";

export function getLocationString(location: Location) {
    return [location.city, location.state].filter(Boolean).join(", ");
}
